export default {
	"fe06c7d68480f0fa88aa753997d9cac2": "抱歉，价格已发生变化!",
	"fa27089ef054b4a53682eaa0249d2990": "系统错误,请稍后再试",
	"4176f4a3daa3decf0f41f77c228867f5": "签约失败,请重新签约"
}
